export default __webpack_public_path__ + "static/media/2-3_image6.cf5d5175.png";